module.exports = __webpack_public_path__ + "static/media/Label_Template_1.609fc6ec.png";